import fs from 'fs'
import path from 'path'

import Head from 'next/head'
import { Remark } from 'react-remark'

import { Header } from 'components/Header'
import { isNavigator, isWebview } from 'utils/browser'
import components from 'configs/remark-markdown-components'

const title = 'Kebijakan Privasi Platform Ruang GTK'

export async function getStaticProps() {
  const filePath = path.join(process.cwd(), '/data/policy.md')

  const content = fs.readFileSync(filePath, 'utf-8')

  return {
    props: {
      content,
    },
  }
}

function PolicyPageHeader() {
  let isOpenedOnWebview =
    typeof window !== 'undefined' && isNavigator ? isWebview() : true

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      {isOpenedOnWebview ? null : (
        <Header
          title={title}
          hasBackButton
          hasOrnament
          variant="primary"
          bordered={false}
          iconLeftSrc="/icon/arrow-left-white.svg"
        />
      )}
    </>
  )
}

export default function PolicyPage({ content }: { content: string }) {
  return (
    <>
      {/* eslint-disable react/no-unknown-property */}
      <style jsx global>{`
        .policy-wrapper > p {
          text-align: justify;
        }
      `}</style>
      <div className="px-4 pt-4 leading-loose pb-14">
        <p className="font-semibold">Terakhir diperbarui: 09/02/2026</p>
        <div className="policy-wrapper">
          <Remark rehypeReactOptions={{ components }}>{content}</Remark>
        </div>
      </div>
    </>
  )
}

PolicyPage.layoutOpts = {
  hasBottomNav: false,
  hasHeader: true,
  header: PolicyPageHeader,
}
